import React from 'react';
import { currencyFormatter } from 'shared/utils/currencyFormatter';
import PriceSummarySegment from './PriceSummarySegment';
import MDIAPrices from './MDIAPrices';
import { IQuote } from 'Quotes/types/store';

interface UpfrontSelectedPriceProps {
  amortised?: boolean | null;
  install_discount: number | null;
  mdia_engineer_price: number | null;
  mdia_install_price: number | null;
  mdia_rack_mount_kit_price: number | null;
  mdia_router_price: number | null;
  net_amortised_install_price: number | null;
  net_install_price: number | null;
  shadow_vlan_price: number | null;
}
interface Prices {
  install_discount: number | null;
  mdia_engineer_price: number | null;
  mdia_install_price: number | null;
  mdia_rack_mount_kit_price: number | null;
  mdia_router_price: number | null;
  net_amortised_install_price: number | null;
  net_install_price: number | null;
  shadow_vlan_price: number | null;
}
interface UpfrontCostsProps {
  selectedPrice: UpfrontSelectedPriceProps;
  secondarySelectedPrice?: UpfrontSelectedPriceProps;
  showShadowVLANPrice: boolean;
  calculateUpFront: (priceAmortised: boolean, netAmortisedInstallPrice: number, netInstallPrice: number) => number;
  priceAmortised: boolean;
  mdiaPrices: IMDIAPrices | undefined;
  quote: IQuote;
  label: string;
}

export interface IMDIAPrices {
  engineerInstallation: number;
  rackMountKit: number;
  router: number;
}

const UpfrontCosts: React.FC<UpfrontCostsProps> = ({
  selectedPrice,
  secondarySelectedPrice,
  showShadowVLANPrice,
  priceAmortised,
  mdiaPrices,
}) => {

  const sumValues = (key: keyof Prices) => (selectedPrice[key] ?? 0) + (secondarySelectedPrice?.[key] ?? 0);

  const totalNetAmortisedInstallPrice = sumValues('net_amortised_install_price');
  const totalShadowVlanPrice = sumValues('shadow_vlan_price');
  const totalNetInstallPrice = sumValues('net_install_price');
  const totalInstallDiscount = sumValues('install_discount');

  const upfrontCharge = priceAmortised ? totalNetAmortisedInstallPrice : totalNetInstallPrice;

  return (
    <>
      <div className="price-summary__segment-wrapper">
        <div className="segment_label">Up-front</div>
        <div>
          <b className="total currency" data-testid="quote-page-upfront-charge">
            {currencyFormatter.format(upfrontCharge)}
          </b>
        </div>
      </div>
      {showShadowVLANPrice && (
        <PriceSummarySegment label="Includes one-off charge for Shadow VLAN of" value={totalShadowVlanPrice} />
      )}

      {!!mdiaPrices && (
        <MDIAPrices
          isManagedDIA={true}
          mdiaRouterPrice={mdiaPrices.router}
          mdiaEngineerPrice={mdiaPrices.engineerInstallation}
          mdiaRackMountKitPrice={mdiaPrices.rackMountKit}
          engineerInstallationRequired={mdiaPrices.engineerInstallation > 0}
        />
      )}

      {totalInstallDiscount > 0 && (
        <PriceSummarySegment label="Includes install discount of" value={totalInstallDiscount} />
      )}
    </>
  );
};

export default UpfrontCosts;
